import { AnalyticsSubject } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { IssueModal } from './issue-modal/index.tsx';

export default AnalyticsSubject('issue')(IssueModal);
